import { useState, useEffect } from 'react';
import { Grid, FormControl, InputLabel, Select, MenuItem, Button, Typography } from '@mui/material';
import initState, { validateAll, initValidationStates } from '../../../utils/stateHandler';
import styles from './options.module.scss'
import SearchableDropdown from '../../SearchableDropdown';
import { Box } from '@mui/system';
import { usePrevious } from '../../../utils/customHooks';

const defaultState = {
    attribute: "",
    operator: "",
    value: null,
}

const Options = ({ data = [], parentState, remove, updateParentState, index, optionHeader, total, operator }) => {
    let stateInitializer = defaultState
    let defaultIsMultiSelect = false
    let defaultSelectedAttributeIndex = -1
    let defaultSelectedOperatorIndex = -1
    if (Object.keys(parentState).length > 0) {
        stateInitializer = parentState
        if (parentState.attribute) {
            defaultSelectedAttributeIndex = data.findIndex(item => item.displayName === parentState.attribute)
        }
        if (parentState.operator) {
            defaultSelectedOperatorIndex = data[defaultSelectedAttributeIndex]?.operatorsAndValues.findIndex(item => item.displayName === parentState.operator)
            if (data[defaultSelectedAttributeIndex]?.operatorsAndValues[defaultSelectedOperatorIndex]?.selectionType === "MULTI_SELECT") {
                defaultIsMultiSelect = true
            }
        }
    }
    const [state, setters, handlers, effectArgs] = initState("Selected Options")(stateInitializer, validate)
    const [isOptionValid, isOptionValidSetters] = initValidationStates(stateInitializer, "Validations");
    const [selectedAttributeIndex, setSelectedAttributeIndex] = useState(defaultSelectedAttributeIndex)
    const [selectedOperatorIndex, setSelectedOperatorIndex] = useState(defaultSelectedOperatorIndex)
    const [isMultiSelect, setIsMultiSelect] = useState(defaultIsMultiSelect)
    const prevAttribute = usePrevious(state.attribute)
    const prevOperator = usePrevious(state.operator)

    function validate(value, key) {
        let isValid = true
        switch (key) {
            case "attribute":
            case "operator":
            case "value":
                if(typeof value === "object"){
                    if(!value?.value){
                        isValid = false
                    }
                }
                else {
                    if(!value){
                        isValid = false
                    }
                }
                break;
                default:
                    break;
        }
        isOptionValidSetters[key].valid(isValid)
    }
    
    useEffect(() => {
        updateParentState(index, state)
        if (validateAll(isOptionValid)) {
            // Do something 
        }
        if (prevAttribute !== state.attribute) {
            setters.value("")
            setters.operator("")
            setSelectedOperatorIndex(-1)
            setSelectedAttributeIndex(data.findIndex(item => item.displayName === state.attribute))
        }
        if (state.operator && prevOperator !== state.operator && selectedAttributeIndex > -1) {
            const newIndex = data[selectedAttributeIndex]?.operatorsAndValues?.findIndex(item => item.displayName === state.operator)
            if (data[selectedAttributeIndex]?.operatorsAndValues[newIndex]?.selectionType === "MULTI_SELECT") {
                setIsMultiSelect(true)
                setters.value([])
            } else {
                setIsMultiSelect(false)
                setters.value("")
            }
            setSelectedOperatorIndex(newIndex)
        }
    }, 
    [...effectArgs])
    
    return (<>
        {index > 0 && <Grid item xs={12}>
            <Box className={styles.operator}>{operator}</Box>
        </Grid>}
        <Grid container className={styles.optionsContainer} justifyContent="space-between">
            <Grid container item xs={12} className={styles.closeButtonContainer} justifyContent="space-between">
                <Grid item xs={11}>
                    <Typography className={styles.header}>{optionHeader}</Typography>
                </Grid>
                <Grid item xs={1} sx={{ height: "26px" }} textAlign="right">
                    {total > 1 && <Button className={styles.closeButton} onClick={() => remove(index)}>X</Button>}
                </Grid>
            </Grid>
            <Grid item xs={4} className={styles.dropdown}>
                <FormControl fullWidth size='small' error={isOptionValid.attribute.touched && !isOptionValid.attribute.valid}>
                    <InputLabel id='attribute'>Attribute</InputLabel>
                    <SearchableDropdown
                        fullWidth
                        labelId="attribute"
                        label="Attribute"
                        value={state.attribute}
                        onChange={handlers.attribute}
                        onBlur={isOptionValidSetters.attribute.touched}
                        options={data.map((item) => (item.displayName))}
                    />
                </FormControl>
            </Grid>
            <Grid item xs={4} className={styles.dropdown}>
                {state.attribute && selectedAttributeIndex > -1 &&
                    <FormControl fullWidth size='small' error={isOptionValid.operator.touched && !isOptionValid.operator.valid}>
                        <InputLabel id='operator'>Operator</InputLabel>
                        <Select
                            className={styles.selectHeight}
                            fullWidth
                            labelId="operator"
                            label="Operator"
                            value={state.operator}
                            onChange={handlers.operator}
                            onBlur={isOptionValidSetters.operator.touched}
                        >
                            {data[selectedAttributeIndex].operatorsAndValues.map((item) => (
                                <MenuItem key={item.displayName} value={item.displayName}>
                                    {item.displayName}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>}
            </Grid>
            <Grid item xs={4} className={styles.dropdown}>
                {state.operator && selectedOperatorIndex > -1 &&
                    <FormControl fullWidth size='small' error={isOptionValid.value.touched && !isOptionValid.value.valid}>
                        <InputLabel id='value'>Value</InputLabel>
                        <SearchableDropdown
                            fullWidth
                            multiple={isMultiSelect}
                            labelId="value"
                            label="Value"
                            value={state.value}
                            onChange={handlers.value}
                            onBlur={isOptionValidSetters.value.touched}
                            options={data[selectedAttributeIndex].operatorsAndValues[selectedOperatorIndex].values.valueList.map(item => (item.displayName))}
                        />
                    </FormControl>}
            </Grid>
        </Grid>
    </>

    );
}

export default Options
